<p-popover #op>
  <ng-template pTemplate="content">
    @for (option of languageOptions; track $index) {
      @if (option.key !== currentLang.key) {
        <div
          class="lang-entry"
          (click)="entryClicked(option)">

          <img
            [src]="'assets/flags/' + option.flagIcon + '.png'"
            height="20px"
            [alt]="'flag-icon-' + option.key" />

          {{ option.label | transloco }}
        </div>
      }
    }
  </ng-template>
</p-popover>

<button
  class="btn btn-sm btn-outline-dark language-button"
  (click)="op.toggle($event)">

  <i class="pi pi-globe"></i>
  {{ currentLang.key.toUpperCase() }}
</button>